import { defineComponent as L, ref as w, computed as F, provide as Q, watchEffect as X, h as I, Fragment as q, onMounted as _, onUnmounted as ee, inject as Y, shallowRef as se } from "vue";
import { useNestedPortals as ie } from "./index354.js";
import { useEventListener as pe } from "./index348.js";
import { useId as G } from "./index327.js";
import { useOutsideClick as ve } from "./index328.js";
import { useResolveButtonType as ce } from "./index329.js";
import { useRootContainers as fe, useMainTreeNode as de } from "./index350.js";
import { useTabDirection as te, Direction as T } from "./index355.js";
import { Hidden as V, Features as z } from "./index332.js";
import { useOpenClosedProvider as me, State as R, useOpenClosed as le } from "./index333.js";
import { Keys as N } from "./index334.js";
import { dom as o } from "./index339.js";
import { getFocusableElements as Z, isFocusableElement as be, focusIn as D, Focus as x, FocusResult as J, FocusableMode as Pe } from "./index340.js";
import { match as M } from "./index342.js";
import { getOwnerDocument as U } from "./index343.js";
import { render as j, Features as H } from "./index345.js";
var Se = ((s) => (s[s.Open = 0] = "Open", s[s.Closed = 1] = "Closed", s))(Se || {});
let oe = Symbol("PopoverContext");
function W(s) {
  let d = Y(oe, null);
  if (d === null) {
    let P = new Error(`<${s} /> is missing a parent <${ye.name} /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(P, W), P;
  }
  return d;
}
let ne = Symbol("PopoverGroupContext");
function ae() {
  return Y(ne, null);
}
let re = Symbol("PopoverPanelContext");
function ge() {
  return Y(re, null);
}
let ye = L({ name: "Popover", inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" } }, setup(s, { slots: d, attrs: P, expose: E }) {
  var m;
  let c = w(null);
  E({ el: c, $el: c });
  let l = w(1), t = w(null), y = w(null), h = w(null), S = w(null), b = F(() => U(c)), i = F(() => {
    var e, a;
    if (!o(t) || !o(S)) return !1;
    for (let K of document.querySelectorAll("body > *")) if (Number(K?.contains(o(t))) ^ Number(K?.contains(o(S)))) return !0;
    let n = Z(), f = n.indexOf(o(t)), C = (f + n.length - 1) % n.length, B = (f + 1) % n.length, A = n[C], ue = n[B];
    return !((e = o(S)) != null && e.contains(A)) && !((a = o(S)) != null && a.contains(ue));
  }), r = { popoverState: l, buttonId: w(null), panelId: w(null), panel: S, button: t, isPortalled: i, beforePanelSentinel: y, afterPanelSentinel: h, togglePopover() {
    l.value = M(l.value, { 0: 1, 1: 0 });
  }, closePopover() {
    l.value !== 1 && (l.value = 1);
  }, close(e) {
    r.closePopover();
    let a = e ? e instanceof HTMLElement ? e : e.value instanceof HTMLElement ? o(e) : o(r.button) : o(r.button);
    a?.focus();
  } };
  Q(oe, r), me(F(() => M(l.value, { 0: R.Open, 1: R.Closed })));
  let $ = { buttonId: r.buttonId, panelId: r.panelId, close() {
    r.closePopover();
  } }, g = ae(), O = g?.registerPopover, [k, p] = ie(), v = fe({ mainTreeNodeRef: g?.mainTreeNodeRef, portals: k, defaultContainers: [t, S] });
  function u() {
    var e, a, n, f;
    return (f = g?.isFocusWithinPopoverGroup()) != null ? f : ((e = b.value) == null ? void 0 : e.activeElement) && (((a = o(t)) == null ? void 0 : a.contains(b.value.activeElement)) || ((n = o(S)) == null ? void 0 : n.contains(b.value.activeElement)));
  }
  return X(() => O?.($)), pe((m = b.value) == null ? void 0 : m.defaultView, "focus", (e) => {
    var a, n;
    e.target !== window && e.target instanceof HTMLElement && l.value === 0 && (u() || t && S && (v.contains(e.target) || (a = o(r.beforePanelSentinel)) != null && a.contains(e.target) || (n = o(r.afterPanelSentinel)) != null && n.contains(e.target) || r.closePopover()));
  }, !0), ve(v.resolveContainers, (e, a) => {
    var n;
    r.closePopover(), be(a, Pe.Loose) || (e.preventDefault(), (n = o(t)) == null || n.focus());
  }, F(() => l.value === 0)), () => {
    let e = { open: l.value === 0, close: r.close };
    return I(q, [I(p, {}, () => j({ theirProps: { ...s, ...P }, ourProps: { ref: c }, slot: e, slots: d, attrs: P, name: "Popover" })), I(v.MainTreeNode)]);
  };
} }), Me = L({ name: "PopoverButton", props: { as: { type: [Object, String], default: "button" }, disabled: { type: [Boolean], default: !1 }, id: { type: String, default: null } }, inheritAttrs: !1, setup(s, { attrs: d, slots: P, expose: E }) {
  var m;
  let c = (m = s.id) != null ? m : `headlessui-popover-button-${G()}`, l = W("PopoverButton"), t = F(() => U(l.button));
  E({ el: l.button, $el: l.button }), _(() => {
    l.buttonId.value = c;
  }), ee(() => {
    l.buttonId.value = null;
  });
  let y = ae(), h = y?.closeOthers, S = ge(), b = F(() => S === null ? !1 : S.value === l.panelId.value), i = w(null), r = `headlessui-focus-sentinel-${G()}`;
  b.value || X(() => {
    l.button.value = o(i);
  });
  let $ = ce(F(() => ({ as: s.as, type: d.type })), i);
  function g(e) {
    var a, n, f, C, B;
    if (b.value) {
      if (l.popoverState.value === 1) return;
      switch (e.key) {
        case N.Space:
        case N.Enter:
          e.preventDefault(), (n = (a = e.target).click) == null || n.call(a), l.closePopover(), (f = o(l.button)) == null || f.focus();
          break;
      }
    } else switch (e.key) {
      case N.Space:
      case N.Enter:
        e.preventDefault(), e.stopPropagation(), l.popoverState.value === 1 && h?.(l.buttonId.value), l.togglePopover();
        break;
      case N.Escape:
        if (l.popoverState.value !== 0) return h?.(l.buttonId.value);
        if (!o(l.button) || (C = t.value) != null && C.activeElement && !((B = o(l.button)) != null && B.contains(t.value.activeElement))) return;
        e.preventDefault(), e.stopPropagation(), l.closePopover();
        break;
    }
  }
  function O(e) {
    b.value || e.key === N.Space && e.preventDefault();
  }
  function k(e) {
    var a, n;
    s.disabled || (b.value ? (l.closePopover(), (a = o(l.button)) == null || a.focus()) : (e.preventDefault(), e.stopPropagation(), l.popoverState.value === 1 && h?.(l.buttonId.value), l.togglePopover(), (n = o(l.button)) == null || n.focus()));
  }
  function p(e) {
    e.preventDefault(), e.stopPropagation();
  }
  let v = te();
  function u() {
    let e = o(l.panel);
    if (!e) return;
    function a() {
      M(v.value, { [T.Forwards]: () => D(e, x.First), [T.Backwards]: () => D(e, x.Last) }) === J.Error && D(Z().filter((n) => n.dataset.headlessuiFocusGuard !== "true"), M(v.value, { [T.Forwards]: x.Next, [T.Backwards]: x.Previous }), { relativeTo: o(l.button) });
    }
    a();
  }
  return () => {
    let e = l.popoverState.value === 0, a = { open: e }, { ...n } = s, f = b.value ? { ref: i, type: $.value, onKeydown: g, onClick: k } : { ref: i, id: c, type: $.value, "aria-expanded": l.popoverState.value === 0, "aria-controls": o(l.panel) ? l.panelId.value : void 0, disabled: s.disabled ? !0 : void 0, onKeydown: g, onKeyup: O, onClick: k, onMousedown: p };
    return I(q, [j({ ourProps: f, theirProps: { ...d, ...n }, slot: a, attrs: d, slots: P, name: "PopoverButton" }), e && !b.value && l.isPortalled.value && I(V, { id: r, features: z.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: u })]);
  };
} });
L({ name: "PopoverOverlay", props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 } }, setup(s, { attrs: d, slots: P }) {
  let E = W("PopoverOverlay"), m = `headlessui-popover-overlay-${G()}`, c = le(), l = F(() => c !== null ? (c.value & R.Open) === R.Open : E.popoverState.value === 0);
  function t() {
    E.closePopover();
  }
  return () => {
    let y = { open: E.popoverState.value === 0 };
    return j({ ourProps: { id: m, "aria-hidden": !0, onClick: t }, theirProps: s, slot: y, attrs: d, slots: P, features: H.RenderStrategy | H.Static, visible: l.value, name: "PopoverOverlay" });
  };
} });
let Le = L({ name: "PopoverPanel", props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, focus: { type: Boolean, default: !1 }, id: { type: String, default: null } }, inheritAttrs: !1, setup(s, { attrs: d, slots: P, expose: E }) {
  var m;
  let c = (m = s.id) != null ? m : `headlessui-popover-panel-${G()}`, { focus: l } = s, t = W("PopoverPanel"), y = F(() => U(t.panel)), h = `headlessui-focus-sentinel-before-${G()}`, S = `headlessui-focus-sentinel-after-${G()}`;
  E({ el: t.panel, $el: t.panel }), _(() => {
    t.panelId.value = c;
  }), ee(() => {
    t.panelId.value = null;
  }), Q(re, t.panelId), X(() => {
    var p, v;
    if (!l || t.popoverState.value !== 0 || !t.panel) return;
    let u = (p = y.value) == null ? void 0 : p.activeElement;
    (v = o(t.panel)) != null && v.contains(u) || D(o(t.panel), x.First);
  });
  let b = le(), i = F(() => b !== null ? (b.value & R.Open) === R.Open : t.popoverState.value === 0);
  function r(p) {
    var v, u;
    switch (p.key) {
      case N.Escape:
        if (t.popoverState.value !== 0 || !o(t.panel) || y.value && !((v = o(t.panel)) != null && v.contains(y.value.activeElement))) return;
        p.preventDefault(), p.stopPropagation(), t.closePopover(), (u = o(t.button)) == null || u.focus();
        break;
    }
  }
  function $(p) {
    var v, u, e, a, n;
    let f = p.relatedTarget;
    f && o(t.panel) && ((v = o(t.panel)) != null && v.contains(f) || (t.closePopover(), ((e = (u = o(t.beforePanelSentinel)) == null ? void 0 : u.contains) != null && e.call(u, f) || (n = (a = o(t.afterPanelSentinel)) == null ? void 0 : a.contains) != null && n.call(a, f)) && f.focus({ preventScroll: !0 })));
  }
  let g = te();
  function O() {
    let p = o(t.panel);
    if (!p) return;
    function v() {
      M(g.value, { [T.Forwards]: () => {
        var u;
        D(p, x.First) === J.Error && ((u = o(t.afterPanelSentinel)) == null || u.focus());
      }, [T.Backwards]: () => {
        var u;
        (u = o(t.button)) == null || u.focus({ preventScroll: !0 });
      } });
    }
    v();
  }
  function k() {
    let p = o(t.panel);
    if (!p) return;
    function v() {
      M(g.value, { [T.Forwards]: () => {
        let u = o(t.button), e = o(t.panel);
        if (!u) return;
        let a = Z(), n = a.indexOf(u), f = a.slice(0, n + 1), C = [...a.slice(n + 1), ...f];
        for (let B of C.slice()) if (B.dataset.headlessuiFocusGuard === "true" || e != null && e.contains(B)) {
          let A = C.indexOf(B);
          A !== -1 && C.splice(A, 1);
        }
        D(C, x.First, { sorted: !1 });
      }, [T.Backwards]: () => {
        var u;
        D(p, x.Previous) === J.Error && ((u = o(t.button)) == null || u.focus());
      } });
    }
    v();
  }
  return () => {
    let p = { open: t.popoverState.value === 0, close: t.close }, { focus: v, ...u } = s, e = { ref: t.panel, id: c, onKeydown: r, onFocusout: l && t.popoverState.value === 0 ? $ : void 0, tabIndex: -1 };
    return j({ ourProps: e, theirProps: { ...d, ...u }, attrs: d, slot: p, slots: { ...P, default: (...a) => {
      var n;
      return [I(q, [i.value && t.isPortalled.value && I(V, { id: h, ref: t.beforePanelSentinel, features: z.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: O }), (n = P.default) == null ? void 0 : n.call(P, ...a), i.value && t.isPortalled.value && I(V, { id: S, ref: t.afterPanelSentinel, features: z.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: k })])];
    } }, features: H.RenderStrategy | H.Static, visible: i.value, name: "PopoverPanel" });
  };
} });
L({ name: "PopoverGroup", inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" } }, setup(s, { attrs: d, slots: P, expose: E }) {
  let m = w(null), c = se([]), l = F(() => U(m)), t = de();
  E({ el: m, $el: m });
  function y(i) {
    let r = c.value.indexOf(i);
    r !== -1 && c.value.splice(r, 1);
  }
  function h(i) {
    return c.value.push(i), () => {
      y(i);
    };
  }
  function S() {
    var i;
    let r = l.value;
    if (!r) return !1;
    let $ = r.activeElement;
    return (i = o(m)) != null && i.contains($) ? !0 : c.value.some((g) => {
      var O, k;
      return ((O = r.getElementById(g.buttonId.value)) == null ? void 0 : O.contains($)) || ((k = r.getElementById(g.panelId.value)) == null ? void 0 : k.contains($));
    });
  }
  function b(i) {
    for (let r of c.value) r.buttonId.value !== i && r.close();
  }
  return Q(ne, { registerPopover: h, unregisterPopover: y, isFocusWithinPopoverGroup: S, closeOthers: b, mainTreeNodeRef: t.mainTreeNodeRef }), () => I(q, [j({ ourProps: { ref: m }, theirProps: { ...s, ...d }, slot: {}, attrs: d, slots: P, name: "PopoverGroup" }), I(t.MainTreeNode)]);
} });
export {
  ye as Popover,
  Me as PopoverButton,
  Le as PopoverPanel
};
